import React, { useState } from "react";
import VendorForm from "../VendorForm/VendorForm";
import HomeIcon from "@mui/icons-material/Home";
import functions from "../../../utils/Api";
import { useDispatch } from "react-redux";
import { dispatchRefreshApiCallVendor } from "../../../Redux/dispatcher";
import { Box } from "@mui/material";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import Toaster from "../../../components/Toaster/Toaster";
import { useNavigate } from "react-router-dom";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs";
import { setToasterStatusMsg } from "../../../Redux/reportSlice";

const CreateVendor = () => {
  const navigate = useNavigate();
  const dispatcher = useDispatch();
  const [disableCreateBtn, setDisableCreateBtn] = useState(false);
  const [vendorDetails, setVendorDetails] = useState({
    vendorName: "",
    vendorLocationId: "",
    vendorEmail: "",
    vendorPhone: "",
    isActive: true,
  });

  const breadCrumbData = [
    {
      label: "Home",
      path: "/cms/dashboard",
    },
  ];

  const handleVendorSubmit = () => {
    setDisableCreateBtn(true);
    try {
      let details = {
        ...vendorDetails,
        vendorEmail: vendorDetails.vendorEmail.toLowerCase(),
      };
      functions
        .post("/vendor", details)
        .then((res) => {
          if (res) {
            setDisableCreateBtn(false);
            dispatcher(dispatchRefreshApiCallVendor(true));
            dispatcher(
              setToasterStatusMsg({
                msg: "Vendor Created successfully",
                severity: "success",
              })
            );
            navigate("/cms/users-list");
          }
        })
        .catch((err) => {
          setDisableCreateBtn(false);
          dispatcher(
            setToasterStatusMsg({
              msg: err,
              severity: "error",
            })
          );
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Box className="Admin-breadCrumb">
        <CustomBreadcrumbs items={breadCrumbData} currentLabel="Users" />
      </Box>
      <VendorForm
        title="Add"
        vendorDetails={vendorDetails}
        setVendorDetails={setVendorDetails}
        handleVendorSubmit={handleVendorSubmit}
        disableCreateBtn={disableCreateBtn}
      />
    </div>
  );
};

export default CreateVendor;
